import { handleCompanyInfo } from './company_Info'
import { handleImpactContentInfo } from './impact_content'
import { handleImpactOverviewInfo } from './impact_overview'
import { handleTargetChart } from './target_chart'
import { handleImpactSolutions } from './impact_solutions'
import { handleAssumptions } from './assumptions'
import { handleMeasurementAndKpis } from './measurement_and_kpis'
import { handleTheoryOfChange } from './theory_of_change'
import type {
  ImpactSummaryType,
  ImpactGoalType,
  CompanyInfoType,
} from '~/types/types'

export const ImpactGoaSlideContent = (
  impact: ImpactGoalType,
  companyInfo: CompanyInfoType,
  impactSummary: ImpactSummaryType,
  locale,
  chartSvg?: string | null,
) => {
  const quantifyGhgEmissionsTicked = impact?.impacts.some(i => i.impactSolutions.some(iS => iS.useGhgSavingPotentialTool))
  const hasChartData = Boolean(chartSvg?.trim())
  const hasClimateSummaryData = (impactSummary?.impactSolutionSummaries || []).some((summary) => {
    const reduction = toFiniteNumber(summary?.totalGhgReduction)
    return reduction !== null
  })
  const shouldRenderClimateSections = Boolean(quantifyGhgEmissionsTicked && hasChartData && hasClimateSummaryData)
  const tocImpacts = impact?.impacts.filter(i => i.conceptId === 93919) || []
  return [
    handleCompanyInfo(companyInfo),
    handleImpactOverviewInfo(impact),
    ...(tocImpacts.length > 0 ? handleTheoryOfChange(tocImpacts[0], locale) ?? []
      : []),
    ...(shouldRenderClimateSections ? handleTargetChart(impactSummary, locale, chartSvg) : []),
    ...(shouldRenderClimateSections ? [handleImpactSolutions(
      impactSummary,
      locale,
    )] : []),
    handleImpactContentInfo(impact?.impacts, locale),
    handleMeasurementAndKpis(impact?.impacts, locale),
    ...(shouldRenderClimateSections ? [handleAssumptions(impactSummary, locale)] : [])
  ]
}

const toFiniteNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '' || value === 'N/A') return null
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}
